import { render, staticRenderFns } from "./Despesas.vue?vue&type=template&id=0358b2ba&scoped=true"
import script from "./Despesas.vue?vue&type=script&lang=js"
export * from "./Despesas.vue?vue&type=script&lang=js"
import style0 from "./Despesas.vue?vue&type=style&index=0&id=0358b2ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0358b2ba",
  null
  
)

export default component.exports